import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../../forms/FormMixin'
import useField from '@/composables/useField'
import { useConfirm } from '@/composables/useConfirm'
import {
  transactionsCommentListResource,
  transactionsCommentCreateResource,
  transactionsCommentReadResource,
  transactionsCommentDeleteResource,
} from '@/services/transactions.service'
  
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentsModal',
  props: {
  promise: Promise,
  close: Function,
  info: Object,
},
  emits: ['readComment'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const scrollContainer = ref(null)
const emit = __emit
const { $t } = useGlobal()
const load = ref(false) 

const commentsList = ref([])

const form = ref({
  text: null
})

const scrollToBottom = () => {
  const container = scrollContainer.value;
  if (container) {
    container.scrollTop = container.scrollHeight;
  }
}

const request = (sendData: any, control: any) => {
  useSubmit( send(sendData, control), control)
}

const fields = ref([
  useField('text', $t('Message'), {
    component: 'd-control-textarea',
    class: 'is-textarea is-textarea--full_h',
    type: 'text',
    rows: 4,
    rules: '',
    comment: true,
  })
])

const readComments = async () => {
  try {
      load.value = true
      const comments = commentsList.value.filter( item => !item.isOwner).map(el => el.id)
      await transactionsCommentReadResource.execute({ transaction: props.info.id }, { comments })
      load.value = false
      props.promise(true)
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}

const removeItem = async (id) => {
  const question = $t('Сonfirm action')
  try {
      await useConfirm(question)
      load.value = true
      await transactionsCommentDeleteResource.execute({ id })
      load.value = false
      getListData(false)
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}

async function getListData(scroll = true) {
  load.value = true
  try {
      const { data: { items, pagination } } = await transactionsCommentListResource.execute({ transaction: props?.info?.id })
      commentsList.value = items
      await readComments()
      if(scroll) scrollToBottom()
      load.value = false
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}

const send = async (sendData: any, control: any) => {
  const preparedData = {
    ...sendData,
    
  }
  const title = $t('Successfully')
  try {
      load.value = true
      await transactionsCommentCreateResource.execute({},{ transaction: props.info.id, ...preparedData })
      load.value = false
      await getListData()
      scrollToBottom()
      form.value.text = null 
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}

getListData(true)

const __returned__ = { props, scrollContainer, emit, $t, load, commentsList, form, scrollToBottom, request, fields, readComments, removeItem, getListData, send, ref, get useSubmit() { return useSubmit }, get useField() { return useField }, get useConfirm() { return useConfirm }, get transactionsCommentListResource() { return transactionsCommentListResource }, get transactionsCommentCreateResource() { return transactionsCommentCreateResource }, get transactionsCommentReadResource() { return transactionsCommentReadResource }, get transactionsCommentDeleteResource() { return transactionsCommentDeleteResource }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})